import { useSelector } from 'react-redux';

import { Pages, selectStreamOnPromo } from '@app/redux/streamOnPromo';
import { selectUserInfo } from '@app/redux/userInfo';

import { FlowEnd } from '../../components';
import ComputerSvg from './ComputerSvg';

export const OrderSummary = () => {
  const { offerDetails } = useSelector(selectStreamOnPromo);
  const {
    userInfo: { email },
  } = useSelector(selectUserInfo);

  return (
    <FlowEnd
      namespace={'OrderConfirmation'}
      page={Pages.orderSummary}
      titleKey="Title.Success"
      descriptionKey="ConfirmationEmail"
      offerName={offerDetails.name}
      email={email}
    >
      <ComputerSvg />
    </FlowEnd>
  );
};
